import { format } from 'date-fns';
import { ActiveBundlePageTypeKeys, TimelineChronologyEntry } from '@/store';
import { comparePageNumbers } from './comparePageNumbers';
import { parseNumbers } from './parseNumbers';
import { transformPagesToPageNumbers } from './transformPagesToPageNumbers';
import { ProviderOption } from '../hooks';

export const areDatesDifferent = (key: string, value: Date | null, entry: TimelineChronologyEntry): boolean => {
  return key === 'date' && value instanceof Date && entry.date !== format(value, 'yyyy-MM-dd');
};

export const areProvidersDifferent = (
  key: string,
  value: ProviderOption | null,
  entry: TimelineChronologyEntry
): boolean => {
  return key === 'provider' && (!!entry.providerId || !!value) && entry.providerId !== value?.code;
};
export const areTimesDifferent = (key: string, value: Date | string, entry: TimelineChronologyEntry): boolean => {
  if (key !== 'time') return false;

  const timeString = value instanceof Date ? format(value, 'HH:mm') : value;

  // If both are null, they are the same (no change needed)
  if (!entry.time && !timeString) return false;

  // If one is null and the other has a value, they are different
  if (!entry.time && timeString) return true;
  if (entry.time && !timeString) return true;

  // If both have values, compare them directly
  return entry.time !== timeString;
};
export const areSummariesDifferent = (key: string, value: string, entry: TimelineChronologyEntry): boolean => {
  return key === 'summary' && (!!entry.summary || !!value) && entry.summary !== value;
};

export const arePagesDifferent = (
  key: string,
  value: string,
  entry: TimelineChronologyEntry,
  activeBundlePageType: ActiveBundlePageTypeKeys
): boolean => {
  return (
    key === 'pages' &&
    (!!entry.pages || !!value) &&
    !comparePageNumbers(transformPagesToPageNumbers(entry.pages, activeBundlePageType), parseNumbers(value))
  );
};

export const areCommentsDifferent = (key: string, value: string, entry: TimelineChronologyEntry): boolean => {
  return key === 'comment' && (!!entry.comment || !!value) && entry.comment !== value;
};
